"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptPrompt = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./AcceptPrompt.css"));
var clsx_1 = __importDefault(require("clsx"));
var NavigationTheming_css_1 = require("./NavigationTheming.css");
var react_2 = require("react");
var dynamic_1 = require("@vanilla-extract/dynamic");
var react_3 = require("react");
exports.AcceptPrompt = (0, react_2.forwardRef)(function (_a, ref) {
    var _b;
    var esignEnabled = _a.esignEnabled, onClose = _a.onClose, overlayPositionProps = _a.overlayPositionProps, paymentsEnabledAndDiscoverable = _a.paymentsEnabledAndDiscoverable;
    var _c = __read((0, react_1.useState)(false), 2), mounted = _c[0], setMounted = _c[1];
    (0, react_3.useEffect)(function () {
        if (!mounted) {
            setMounted(true);
        }
    }, [mounted]);
    var copy = function () {
        if (paymentsEnabledAndDiscoverable) {
            return {
                title: "Online payment available",
                content: "When you’re ready, click ‘Accept’ to begin the process to sign and pay this document.",
            };
        }
        else {
            switch (esignEnabled) {
                case true:
                    return {
                        title: "How to sign & accept",
                        content: "When you’re ready, click ‘Accept’ to begin the process to sign and accept this document.",
                    };
                    break;
                default:
                    return {
                        title: "How to accept",
                        content: "When you’re ready, click ‘Accept’ to accept this document.",
                    };
                    break;
            }
        }
    };
    var caretVars = overlayPositionProps
        ? (0, dynamic_1.assignInlineVars)((_b = {},
            _b[styles.caretTop] = "".concat(overlayPositionProps.caret.top, "px"),
            _b[styles.caretLeft] = "".concat(overlayPositionProps.caret.left, "px"),
            _b))
        : {};
    return (react_1.default.createElement("div", { ref: ref, className: styles.prompt({ positioned: mounted }), style: __assign({}, overlayPositionProps === null || overlayPositionProps === void 0 ? void 0 : overlayPositionProps.overlay) },
        react_1.default.createElement(kaleidoscope_1.Panel, { className: (0, clsx_1.default)(styles.panel, NavigationTheming_css_1.navigationThemeLightOverride) },
            react_1.default.createElement("div", { className: styles.caret, style: __assign({}, caretVars) }),
            react_1.default.createElement("div", { className: styles.closeButton },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: onClose })),
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "s", padding: "l" },
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", align: "center" },
                    react_1.default.createElement("div", { className: styles.tickIcon },
                        react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Large })),
                    react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true }, copy().title),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center" }, copy().content)),
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: onClose },
                    react_1.default.createElement(icons_1.ThumbsUp, null),
                    " Got it")))));
});
exports.AcceptPrompt.displayName = "AcceptPrompt";
